
(function($,w){$(function(){

    /**********************************************************************************
        Handle the form validation and transmission
    **********************************************************************************/

    class formHandling
    {

        setProperties()
        {

            this.outer;

            this.button;

            this.choose;

            this.message;

            this.describe;

            this.form = $( 'form.frm-fluent-form' );

            this.amount  = $( 'input[name="amount"]' );

            this.percent = $( 'input[name="percent"]' );

            // ############ Booking

            this.info;

            this.label;

            this.header;

            this.booking;

            this.quantity = $( 'input[name="quantity"]' );

        } // end setProperties

        constructor()
        {

            this.setProperties();

            this.initialize();

            this.bindEvents();

        } // end constructor

        initialize( self = this )
        {

            $( 'select.readonly' ).attr( 'disabled', true );
            this.prepareVerificationCodeField();

        } // end initialize

        prepareVerificationCodeField()
        {

            this.form.find( 'input[name="verificationCode"], input.verification-code' ).each( function()
            {

                let target = $( this );

                target.attr({
                    'type': 'text',
                    'inputmode': 'numeric',
                    'pattern': '[0-9]*',
                    'autocomplete': 'one-time-code',
                    'maxlength': 6,
                });

                target.off( 'input.wwlVerificationCode' ).on( 'input.wwlVerificationCode', function()
                {
                    let value = String( target.val() || '' ).replace( /\D+/g, '' ).slice( 0, 6 );

                    if ( target.val() !== value )
                        target.val( value );

                });

            });

        } // end prepareVerificationCodeField

        ajax( obj, self = this )
        {

            let request = $( '#coupon-request' );

            obj.action = 'couponsHandler';
            obj.nonce  = request.data( 'nonce' );

            $.ajax(
            {

                data : obj,
                type : 'post',
                url  : request.data( 'url' ),

                success: function( data )
                {

                    let resp = JSON.parse( data );

                    self.message = $( '#coupon-message-p' );
                    self.outer   = self.message.parent();

                    self.button.addClass( 'locked' );

                    // Maybe form validate error
                    self.coupon.attr('aria-invalid', 'false');
                    self.coupon.siblings( '.error.text-danger' ).remove();
                    self.coupon.closest( '.ff-el-group' ).removeClass( 'ff-el-is-error' );

                    if ( resp.isValid ) // Coupon is valid
                    {

                        let show, amount,
                            slect = $( 'select[name="count"]' ),
                            count = parseFloat( slect.val() ),
                            price = count * parseFloat( $( 'input[name="toPay"]' ).val() );

                        if ( 'percent' == resp.type )
                        {

                            self.amount.val( 0.0 );
                            self.percent.val( resp.value );

                            amount = price * resp.value;

                            show = resp.value * 100 + ' %';

                        }

                        else
                        {

                            if ( resp.value > price ) // For free
                                amount = price;

                            else
                                amount = resp.value;

                            self.percent.val( 0.0 );
                            self.amount.val( amount / count );

                            show = resp.value.toLocaleString(
                                'de-DE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                    minimumFractionDigits: 2
                            });
                        }

                        self.amount.trigger( 'change' );
                        self.percent.trigger( 'change' );

                        $( '#coupon-button' ).addClass( 'success locked' ) // green
                            .find( '.coupon-button--text' ).text( 'Aktiv' );

                        self.coupon.addClass( 'active' ).closest( 'div.ff-el-group' ).find( 'label' ) // Yellow
                            .text( 'Gutschein' );

                        let amntShow = amount.toLocaleString(
                            'de-DE', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2
                        });

                        if ( amount == price ) // For free, no purchase
                        {

                            let html,
                                choose = $( '#have-to-choose' ), // Sentence instead price table if coupon set price to 0
                                describe = $( '.coupon-description' ).children( 'p' );

                            self.choose = choose.text();
                            self.describe = describe.text();

                            self.coupon.closest( 'div.ff-el-group' ).find( 'label' )
                                .html( 'Gutschein ›› <span style="color:#e7b053">-' + amntShow + '</span>' );

                            html = '<b><span style="color:#E7B053">Gutschein angewendet</span></b> – 100 % Nachlass. Keine Barauszahlung möglich.'

                            if ( self.info )
                                html = self.info + '<br/>' + html;

                            choose.html( html );
                            describe.text( 'Der eingegebene Gutscheincode ist gültig.' );

                        }

                        else // Add entry to purchase info table
                        {

                            let code = self.coupon.val(),
                                row  = `
                                <tr id="coupon-row">
                                    <td>Gutschein "${code}" (${show})</td>
                                    <td>-</td>
                                    <td>1</td>
                                    <td>-${amntShow}</td>
                                </tr>`;

                            $( 'div.ff_dynamic_payment_summary' ).find( 'tbody' ).prepend( row );

                        }

                        $( '#coupon-loader' ).removeClass( 'active' );

                    }

                    else
                    {

                        let old = self.message.text();

                        self.message.text( resp.message );

                        self.button.removeClass( 'success' ).addClass( 'error' ); // red

                        self.outer.slideDown( 500, function()
                        {

                            setTimeout( () =>
                            {

                                self.outer.slideUp( 500, function()
                                {

                                    self.message.text( old );
                                    self.button.removeClass( 'error locked' ) // yellow
                                        .find( '.coupon-button--text' ).text( 'Anwenden' );
                                    self.coupon.removeAttr( 'readonly' ).removeClass( 'active' ).val( '' ).trigger( 'change' );
                                    self.coupon.closest( 'div.ff-el-group' ).find( 'label' )
                                        .text( 'Gutschein' );
                                    $( '#coupon-row' ).remove();

                                    if ( self.choose )
                                    {

                                        $( '#have-to-choose' ).text( self.choose );

                                        self.choose = false;

                                    }

                                    if ( self.describe )
                                    {

                                        $( '.coupon-description' ).children( 'p' ).text( self.describe );

                                        self.describe = false;

                                    }

                                    setTimeout( () => { $( '#coupon-loader' ).removeClass( 'active' ); }, 300 );

                                });
                            }, 3000 );
                        });

                    }

                    console.log( 'Success function' );

                },

                error: function( data )
                {

                    $( '#coupon-button' ).css( 'backgroundColor', '#c25e5e' ); // red

                    $( '#coupon-loader' ).removeClass( 'active' );

                    console.log( 'Hat nicht funktioniert..' );

                }
            });
        } // end ajax

        getData()
        {

            return {
                'email'  : $( 'input[name="email"]' ).val(),
                'count'  : $( 'select[name="count"]' ).val(),
                'coupon' : this.coupon.val(),
                'amount' : $( 'input[name="toPay"]' ).val(),
                'slug'   : $( 'input[name="slug"]' ).val(),
            }

        } // getData

        dateString( startTime )
        {

            const date = new Date( startTime.replace( ' ', 'T' ) );

            let out = new Intl.DateTimeFormat( 'de-DE',
            {
                day    : '2-digit',
                month  : 'short',
                year   : 'numeric',
                hour   : '2-digit',
                minute : '2-digit'
            }).format( date );

            return out;

        } // end dateString

        syncGroup( group )
        {

            let input = group.find( '.ff-el-form-control' ).first(),
                hasValue = !! ( input.val() && String( input.val() ).trim().length );

            group.toggleClass( 'has-value', hasValue );

        } // end syncGroup

        animate( sel )
        {

            let off  = 40,
                time = 400,
                elem = $( sel ),
                wid  = ( $( w ).width() < 981 ? -50 : 170 ) + ( off ) - ( $( '#main-header' ).hasClass( 'sticky' ) ? 95 : 0 );

            if ( elem.length < 1 )
                return false;

            $( 'html, body' ).animate({ scrollTop: elem.offset().top - wid }, time, 'swing', function() { return; });

        } // end animate

        bindEvents( self = this )
        {

            // Check the code
            $( '#coupon-button' ).on( 'click', function( e )
            {

                // Reset to avoid calculation errors
                self.amount.val( 0.0 ).trigger( 'change' );
                self.percent.val( 0.0 ).trigger( 'change' );

                // First time set
                self.button = $( this );

                self.coupon = $( 'input[name="coupon"]' );

                if ( '' == self.coupon.val() || self.button.hasClass( 'locked' ) )
                {

                    self.button.addClass( 'error' ); // red

                    return setTimeout( () => { self.button.removeClass( 'error' ); }, 500 ); // yellow

                }

                $( '#coupon-loader' ).addClass( 'active' );

                self.button.addClass( 'locked' );

                self.coupon.attr( 'readonly', 'readonly' );

                self.ajax( self.getData() );

            });


            if ( this.form.hasClass( 'booking' ) )
            {

                this.label = $( 'input[name="toPay"]' ).closest( 'div.ff-el-group' ).find( 'label' );

                this.booking = $( 'input[name="booking"]' );

                this.title = $( 'input[name="title"]' );

                this.count = $( 'select[name="count"]' );

                this.header = this.label.text();

                const parseBookingData = ( attempt = 0 ) =>
                {

                    let booking = $( 'input[name="booking"]' ),
                        value = booking.length ? String( booking.val() || '' ).trim() : '',
                        data,
                        location,
                        date,
                        info,
                        count,
                        lngth;

                    self.bookingParseTimer = false;

                    if ( '' === value )
                    {

                        if ( attempt >= 20 )
                            return;

                        self.bookingParseTimer = w.setTimeout( () => { parseBookingData( attempt + 1 ); }, 50 );

                        return;

                    }

                    try
                    {

                        data = JSON.parse( value );

                    }

                    catch ( error )
                    {

                        return;

                    }

                    if ( ! data || ! data.form || ! data.form.location_config || ! data.start_time )
                        return;

                    self.booking = booking;

                    switch( data.duration )
                    {

                      case '90' :
                        count = 2;
                        break;

                      default:
                        count = 1;
                    }

                    location = ( 'zoom_meeting' == data.form.location_config.driverType ) ? 'Zoom' : 'Google Meet';
                    date  = self.dateString( data.start_time ) + ' Uhr';
                    lngth = count * 45;
                    info = `
                        <span class="header">${self.header}</span>
                        <br/>
                        <span class="body">Termin am ${date}, Dauer ${count} x 45 Minuten, via ${location}, je 45 Min. zu</span>
                    `;

                    self.info = info;

                    self.title.val( self.header + '|' + `Termin am ${date}, Dauer ${count} x 45 Minuten, via ${location}` );

                    self.label.text( info );

                    self.count.val( count ).trigger( 'change' );

                    self.quantity.val( count ).trigger( 'change' );

                };

                this.form.on( 'click', 'div.fcal_spot_name', function()
                {

                    if ( self.bookingParseTimer )
                        return;

                    self.bookingParseTimer = w.setTimeout( () => { parseBookingData(); }, 10 );

                });

                this.form.on( 'click', 'div.fcal_back ', function()
                {

                    if ( self.bookingParseTimer )
                    {

                        w.clearTimeout( self.bookingParseTimer );

                        self.bookingParseTimer = false;

                    }

                    self.info = false;

                    self.title.val( '' );

                    self.label.text( self.header );

                    self.count.val( '' ).trigger( 'change' );

                    self.quantity.val( 0 ).trigger( 'change' );

                });

            } // endif

            // Update quantity field
            $( 'select[name="count"]' ).on( 'change', function()
            {

                // Reset to avoid calculation errors
                self.amount.val( 0.0 ).trigger( 'change' );
                self.percent.val( 0.0 ).trigger( 'change' );

                if ( ! self.button )
                    self.button = $( '#coupon-button' );

                // Update the hidden quantity field
                $( 'input[name="quantity"]' ).val( $( this ).val() ).trigger( 'change' );

                self.coupon = $( 'input[name="coupon"]' );

                if ( '' != self.coupon.val() )
                {

                    $( '#coupon-loader' ).addClass( 'active' );

                    self.ajax( self.getData() );

                }

            });

            // Check quantity field on update
            $( 'input[name="quantity"]' ).on( 'change', function()
            {

                let t = $( this );

                if ( '' != t.val() && ! ( t.val() in JSON.parse( $( 'input[name="prices"]' ).val() ).options ) )
                    w.location.reload();

            });

            // Label animation
            this.form.find( '.ff-el-group' ).each( function()
            {

                let group = $( this ),
                    input = group.find( '.ff-el-form-control' );

                self.syncGroup( group );

                input.on( 'focus', function(){ group.addClass( 'is-focus' ); });
                input.on( 'blur',  function(){ group.removeClass( 'is-focus' ); self.syncGroup( group ); });
                input.on('input change', function(){ self.syncGroup( group ); });

            });

            // Form animate
            document.addEventListener( 'click', function ( e )
            {

                const button = e.target.closest( 'button.ff-btn' );

                if ( ! button || button.disabled || ( button.offsetParent === null ) )
                    return;

                self.animate( '#pay-form' );

            }, true );

            $( document ).on( 'fluentform_submission_success', function ( e, data )
            {

                $( 'html, body' ).stop( true );

                self.animate( '#pay-form' );

                // Forward to profile page
                setTimeout( () => { w.location.href = w.location.origin + '/profil/'; }, 7000 );

            });

            // Validation Code
            $( document ).on( 'fluentform_submission_failed', function( e, data )
            {
                let response = data && data.response && data.response.responseJSON ? data.response.responseJSON : false,
                    errors = response && 'object' == typeof response.errors ? response.errors : {};

                $( 'html, body' ).stop( true );

                if ( 'verificationCode' in errors )
                {

                    self.prepareVerificationCodeField();

                    $( 'div.verification-code' ).slideDown( 300, function()
                    {

                        let target = $( this ).find( 'input.verification-code' );

                        self.animate( 'div.ff-payment_summary_component' );
                        target.trigger( 'input.wwlVerificationCode' );
                    });
                }

                else
                    self.animate( '#pay-form' );

            });

        } // end bindEvents
    } // end class formHandling

    new formHandling;

});}(jQuery,window));
